import { IAction } from './action';

export class SetTitle implements IAction {
    constructor(public title: string) {}
}
